jQuery(document).ready(function ($) {

  // Lazy loading images with unveil plugin
  $("img").unveil(100);

  // Initialize the main carousel with fade effect
  $(".carousel-front").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    lazyLoad: "ondemand",
    fade: true,
    arrows: true,
    prevArrow: '<div class="slick-prev">back</div>',
    nextArrow: '<div class="slick-next">next</div>',
  });





  // Initialize WooCommerce product carousel with responsive settings
  $(".woocommerce-product-slick").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '<div class="slick-prev">back</div>',
    nextArrow: '<div class="slick-next">next</div>',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });


      lightbox.option({
        'resizeDuration': 200,
        'wrapAround': true
    });

  // Add class to product list and initialize another slick carousel
  $(".slick-prod .products").addClass("woocommerce-product-list");


  $(".woocommerce-product-list").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '<div class="slick-prev">back</div>',
    nextArrow: '<div class="slick-next">next</div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });



  // Store scroll position and restore it on page reload
  $(function () {
    $(window).unload(function () {
      var scrollPosition = $("div#element").scrollTop();
      localStorage.setItem("scrollPosition", scrollPosition);
    });
    if (localStorage.scrollPosition) {
      $("div#element").scrollTop(localStorage.getItem("scrollPosition"));
    }
  });

// Toggle search form visibility
$(".searchform .close").click(function () {
  $(".searchform").removeClass("searchform-active");
});

$(".btn-search").click(function () {
  $(".searchform").toggleClass("searchform-active");
  $(".user, .basket, .navh-bottom").removeClass("user-active basket-active navh-bottom-active"); // Close other elements
});

// Toggle user menu and basket visibility
$(".user button, .btn-user").click(function () {
  $(".user").toggleClass("user-active");
  $(".basket").removeClass("basket-active");
  $(".searchform").removeClass("searchform-active"); // Close other elements
});

$(".basket button, .btn-basket").click(function () {
  $(".basket").toggleClass("basket-active");
  $(".user").removeClass("user-active");
  $(".searchform").removeClass("searchform-active"); // Close other elements
});

// Toggle main menu visibility
$(".btn-menu").click(function () {
  $(".navh-bottom").toggleClass("navh-bottom-active");
  $(".user, .basket").removeClass("user-active basket-active"); // Close other elements
  $(".searchform").removeClass("searchform-active"); // Close other elements
});

// Toggle navh elements visibility
$(".navh-toggle").click(function () {
  $(".navh-contact, .navh-social, .navh-menu, .navh-close").css({ display: "flex" });
  $(".user, .basket, .navh-bottom").removeClass("user-active basket-active navh-bottom-active"); // Close other elements
});

$(".navh-close").click(function () {
  $(".navh-contact, .navh-social, .navh-menu, .navh-close").css({ display: "none" });
});

// Toggle sidebar filter visibility
$("#filters").click(function () {
  $("#sidebar").toggle();
  $(".user, .basket, .navh-bottom").removeClass("user-active basket-active navh-bottom-active"); // Close other elements
});


  // Show "Back to Top" button and scroll to the top
  $(window).scroll(function () {
    var height = $(window).scrollTop();
    if (height > 100) {
      $("#back2Top").fadeIn();
    } else {
      $("#back2Top").fadeOut();
    }
  });

  $("#back2Top").click(function (event) {
    event.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, "fast");
    return false;
  });

  // Handle AJAX form submission
  $("#form-size, #fprojectForm, #projectForm").submit(function (event) {
    event.preventDefault();
    var form = $(this);
    $.ajax({
      url: form.attr("action"),
      data: form.serialize(),
      type: form.attr("method"),
      dataType: "text",
      beforeSend: function () {
        form.find("button").html('<i class="fas fa-spinner fa-pulse mr-2"></i> Sending');
      },
      success: function (data) {
        form.html(data);
      },
      error: function () {
        form.find("button").html('<i class="fas fa-search fa-pulse mr-2"></i> Error');
      },
    });
    return false;
  });

  // Newsletter (MailPoet): po kliknięciu „Zapisz” pokaż własny komunikat sukcesu.
  // MailPoet dodaje klasę `mailpoet_form_successfully_send` na <form>.
  (function initMailPoetNewsletterSuccessMessage() {
    var successText = "Witaj wśród Dam!";

    var applyToForm = function (form) {
      if (!form || !form.classList) return;
      if (!form.classList.contains("mailpoet_form_successfully_send")) return;

      // 1) Preferuj natywny element sukcesu, jeśli istnieje.
      var successEl = form.querySelector(".mailpoet_validate_success");
      if (successEl) {
        successEl.textContent = successText;
        return;
      }

      // 2) W przeciwnym razie wstaw do message-box.
      var messageBox = form.querySelector(".mailpoet_message");
      if (!messageBox) return;

      var p = messageBox.querySelector(".mailpoet_validate_success") || messageBox.querySelector("p");
      if (!p) {
        p = document.createElement("p");
        messageBox.appendChild(p);
      }
      p.classList.add("mailpoet_validate_success");
      p.textContent = successText;
    };

    var applyAll = function () {
      var forms = document.querySelectorAll(".newsletter form.mailpoet_form");
      if (!forms || !forms.length) return;
      forms.forEach(applyToForm);
    };

    // Start: od razu po ready.
    applyAll();

    // Obserwuj cały dokument, bo MailPoet potrafi modyfikować DOM po submit.
    if (window.MutationObserver) {
      var rootObserver = new MutationObserver(function () {
        applyAll();
      });
      rootObserver.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    // Dodatkowo: po submit wymuś ponowną próbę po chwili.
    document.addEventListener(
      "submit",
      function (e) {
        var target = e.target;
        if (!target || !target.matches) return;
        if (!target.matches(".newsletter form.mailpoet_form")) return;
        setTimeout(applyAll, 150);
        setTimeout(applyAll, 600);
        setTimeout(applyAll, 1500);
      },
      true
    );
  })();
});




